import { z } from 'zod';

export const SegmentSchema = z.enum(['KI', 'IT', 'ProLo', 'V&S', 'HR']);
export type Segment = z.infer<typeof SegmentSchema>;

export const ProjectKeySchema = z
  .string()
  .regex(/^P\d{6}$/, 'project_key muss dem Format P<6 Ziffern> folgen, z. B. P020395');
export type ProjectKey = z.infer<typeof ProjectKeySchema>;

export const UuidSchema = z.string().uuid();
export const IsoDateTimeSchema = z.string().datetime();
